module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-4-photo-6-f1b100e7ffa63e12760e69d6d1fd4595.webp";